export default __webpack_public_path__ + "static/webcertain-logo-894c669fe82b0569f47a6affae547210.png";